import React from 'react';
import { AssistantProgress, progressLabel } from './assistantLive';

interface AssistantActionCardProps {
  step: AssistantProgress;
  label: string;
  facts?: string[];
  path?: string;
  onOpen?: (path: string) => void;
}

const AssistantActionCard: React.FC<AssistantActionCardProps> = ({
  step,
  label,
  facts,
  path,
  onOpen
}) => (
  <div className={`assistant-action-card is-${step}`}>
    <div className="assistant-action-card__row">
      <p>{progressLabel(step, label)}</p>
      {step === 'done' && path && onOpen && (
        <button type="button" className="assistant-action-card__go" onClick={() => onOpen(path)}>
          Voir
        </button>
      )}
    </div>
    {facts && facts.length > 0 && (
      <ul>
        {facts.map((fact) => (
          <li key={fact}>{fact}</li>
        ))}
      </ul>
    )}
  </div>
);

export default AssistantActionCard;
